interface BrazeConfig {
  braze_enabled: boolean
  braze_sdk_endpoint: string
  braze_web_sdk_api_key: string
}

// A thin wrapper around the shared `braze-tc` library's `brazeInitialise()`,
// gated on `Config.braze_enabled`.
//
// Consent gating (Didomi) is handled internally by `brazeInitialise()`, so
// calling this unconditionally when the SDK is enabled is safe - it won't
// actually initialise Braze until the reader has consented, or is in a
// region where consent isn't required.
//
// `@braze/web-sdk` is ~72KB gzipped, so `brazeInitialise` is dynamically
// imported here rather than statically at the top of this file. That keeps
// the SDK out of the `application.js` bundle entirely when Braze is
// disabled, which is the default in staging and production.
export default class Braze {
  static async start(config: BrazeConfig): Promise<void> {
    if (!config.braze_enabled) {
      return
    }

    const { brazeInitialise } = await import("@theconversation/shared-libraries/braze-tc")

    brazeInitialise(config.braze_sdk_endpoint, config.braze_web_sdk_api_key)
  }
}
